import { Box, Flex } from '@chakra-ui/react';
import { Tag, Text } from '@kula-ai/components';
import type { DashboardSection } from '../../../types';

// Tags carry the built-in truncation title, so a long phrase shows its full
// text on hover without a second tooltip layered on top.
export const TagsSection = ({ section }: { section: DashboardSection }) => (
  <Flex direction="column" gap="16px">
    {(section.tagSets ?? []).map((ts) => (
      <Box key={ts.label}>
        <Text variant="overhead" style={{ display: 'block', marginBottom: 10 }}>
          {ts.label}
        </Text>
        <Flex wrap="wrap" gap="6px">
          {ts.tags.map((t) => (
            <Tag key={t} label={t} size="md" variant="neutral" />
          ))}
        </Flex>
      </Box>
    ))}
    {section.text && <Text variant="p">{section.text}</Text>}
  </Flex>
);
